<template>
  <div>
    <congrats-modal
      :coins="coins.coins"
      :points="coins.points"
      :description="coins.description"
      :idModal="`${moduleOrder}-modal`"
      @onClose="routePlanningView"
    ></congrats-modal>

    <div class="planningStyle d-flex justify-content-between align-items-center w-100 mb-2">
      <label class="text-main font-weight-bold m-0">
        {{ titleModule }}
      </label>
    </div>

    <b-form v-on:submit.prevent="validateSendData()">
      <span>
        <b-row >
          <b-col cols="12">
            <label for="range-1">
              <i class="material-icons text-main align-middle mr-1">schedule</i>
              {{ moduleQuestions.question2 }}
            </label>
            <b-row
              v-for="(day, idx) in daysSelected.daysWhat"
              :key="idx"
              class="d-flex justify-content-between align-items-center mb-2"
            >
              <div
                class="d-flex justify-content-center align-items-center py-2"
              >
                <input
                  :id="`${moduleQuestions.title}_what_${day.title}`"
                  type="checkbox"
                  v-model="day.value"
                  class="atm-input-checkbox"
                />
                <label
                  :for="`${moduleQuestions.title}_what_${day.title}`"
                  class="material-icons-round"
                >
                </label>
                <label :for="`${moduleQuestions.title}_what_${day.title}`" class="m-0">
                  {{ day.title }}
                </label>
              </div>
              <input
                v-show="day.value"
                :id="day.title"
                v-model="day.time"
                type="time"
                class="atm-input-time"
                required
              />
            </b-row>
          </b-col>

          <b-col cols="12" class="mt-3">
            <label>
              <i class="material-icons text-main align-middle mr-1">
                location_on
              </i>
              {{ moduleQuestions.question3 }}
            </label>
            <input
              v-model="questionsAnswers.question3"
              placeholder="Enter your place"
              class="atm-input w-100"
            />
          </b-col>

          <b-col cols="12" class="mt-3">
            <label>
              <i class="material-icons text-main align-middle mr-1">
                assignment_turned_in
              </i>
              {{ moduleQuestions.question4 }}
            </label>
            <input
              v-model="questionsAnswers.question4"
              type="text"
              placeholder="(i.e., what activities will be completed)"
              class="atm-input w-100"
            />
          </b-col>

          <b-col cols="12" class="mt-3">
            <label>
              <i class="material-icons text-main align-middle mr-1">
                notifications
              </i>
              {{ moduleQuestions.question5 }}
            </label>
            <select
              v-model="questionsAnswers.question5"
              class="atm-input w-100"
            >
              <option
                v-for="(option, optionIdx) in rememberOptions"
                :key="optionIdx"
                :value="option.id"
              >
                {{ option.name }}
              </option>
            </select>
            <span v-for="(q5, idx) in rememberOptions" :key="idx">
              <b-form-input
                v-if="q5.need_extra_data && questionsAnswers.question5 == q5.id"
                class="my-2"
                v-model="extralabelInput"
                placeholder="Enter your answer"
              ></b-form-input>
            </span>
          </b-col>

          <b-col cols="12" class="mt-3" v-if="moduleQuestions.question6">
            <label>
              <i class="material-icons text-main align-middle mr-1">
                person
              </i>
              {{ moduleQuestions.question6(parentName) }}
            </label>
            <b-row
              v-for="(day, idx) in daysSelected.daysWhere"
              :key="idx"
              class="d-flex justify-content-between align-items-center mb-2"
            >
              <div
                class="d-flex justify-content-center align-items-center py-2"
              >
                <div class="d-flex justify-content-center align-items-center">
                  <input
                    :id="`${moduleQuestions.title}_where_${day.title}`"
                    type="checkbox"
                    v-model="day.value"
                    class="atm-input-checkbox"
                  />
                  <label
                    :for="`${moduleQuestions.title}_where_${day.title}`"
                    class="material-icons-round"
                  >
                  </label>
                  <label :for="`${moduleQuestions.title}_where_${day.title}`" class="m-0">{{
                    day.title
                  }}</label>
                </div>
              </div>
              <input
                v-show="day.value"
                :id="day.title"
                type="time"
                class="atm-input-time"
                v-model="day.time"
                required
              />
            </b-row>
          </b-col>
          <small v-if="errorDays" class="text-danger mt-3 ml-2">
            <b>Select at least one day in the question:</b>
            <p class="m-0">{{ moduleQuestions.question2 }}</p>
          </small>
          <div class="d-flex mt-3 w-100">
            <button type="submit" class="atm-button bg-main mx-auto mt-2 w-50">
              Save
            </button>
          </div>
        </b-row>
      </span>
    </b-form>

    <b-modal
      v-model="modalValidateSendData"
      ref="modal"
      title="Please confirm"
      okTitle="Save"
      cancelTitle="Back"
      @hidden="resetModal"
      @ok="sendData"
      :hideHeaderClose="true"
    >
      <div class="d-block">
        <p>Are you sure you want to send these empty fields?</p>
        <ul>
          <li v-for="(day, idx) in emptyFileds" :key="idx">
            {{ emptyFileds[idx] }}
          </li>
        </ul>
      </div>
    </b-modal>
  </div>
</template>

<script>

import CongratsModal from '@/components/Congrats/CongratsModal.vue';
import modulesMock from '../mock/moduleQuestions.mock'
import { getPlansRememberOptions,createNewPlan,editPlan } from '../services'
import { useSessionStore } from '@/common'

export default {
  components: { CongratsModal },
  props: {
    moduleOrder: Number,
    plan: { type: Object },
    parentName: { type:String, required: true },
    childName:{ type:String, required: true }
  },
  data: function() {
    const sessionStore = useSessionStore() 
    return {
      sessionStore,
      coins: {
        description: '',
        coins: 0,
        points: 0
      },
      questionsAnswers: {
        question3: null,
        question4: null,
        question5: null
      },
      daysSelected: {
        daysWhat: [
          { title: 'Monday', value: false, time: '12:00', code: '1' },
          { title: 'Tuesday', value: false, time: '12:00', code: '2' },
          { title: 'Wednesday', value: false, time: '12:00', code: '3' },
          { title: 'Thursday', value: false, time: '12:00', code: '4' },
          { title: 'Friday', value: false, time: '12:00', code: '5' },
          { title: 'Saturday', value: false, time: '12:00', code: '6' },
          { title: 'Sunday', value: false, time: '12:00', code: '7' }
        ],
        daysWhere: [
          { title: 'Monday', value: false, time: '12:00', code: '1' },
          { title: 'Tuesday', value: false, time: '12:00', code: '2' },
          { title: 'Wednesday', value: false, time: '12:00', code: '3' },
          { title: 'Thursday', value: false, time: '12:00', code: '4' },
          { title: 'Friday', value: false, time: '12:00', code: '5' },
          { title: 'Saturday', value: false, time: '12:00', code: '6' },
          { title: 'Sunday', value: false, time: '12:00', code: '7' }
        ]
      },
      rememberOptions:[],
      emptyFileds: [],
      extralabelInput: '',
      errorDays: false,
      modalValidateSendData: false,
      newPlan:{}
    };
  },
  computed: {
    moduleQuestions(){
      return modulesMock.modulesQuestions[this.moduleOrder]
    },
    userIsAParent(){
      return this.sessionStore.profileType === "parent"
    },
    titleModule(){
      return this.moduleOrder === 5 ? 'Self-Management Plan' : 'Create your plan'
    },
  },
  mounted() {
    getPlansRememberOptions()
    .then((response)=>{
      this.rememberOptions = response
    })
    
    if(this.plan){
      this.plan.what_days.forEach(element => {
        this.daysSelected.daysWhat.forEach(day => {
          if (element.day_of_week == day.code) {
            day.value = true;
            day.time = element.hour;
          }
        });
      });
      this.questionsAnswers.question3 = this.plan.where_place;
      this.questionsAnswers.question4 = this.plan.what_activities;
      this.questionsAnswers.question5 = this.plan.how_remember_id;
      this.extralabelInput = this.plan.extra_data_how_remember;

      this.plan.when_check_days.forEach(element => {
        this.daysSelected.daysWhere.forEach(day => {
          if (element.day_of_week == day.code) {
            day.value = true;
            day.time = element.hour;
          }
        });
      });
    }
  },
  methods: {
    resetModal() {
      this.emptyFileds = [];
    },
    validateSendData() {
      this.errorDays = false;
      this.modalValidateSendData = false;

      const currentModuleQuest = this.moduleQuestions

      const question2Empty = !this.daysSelected.daysWhat.some(day => day.value);

      if (question2Empty) {
        this.emptyFileds.push(currentModuleQuest.question2);
        this.errorDays = true;
      }

      const questionKeys = Object.keys(this.questionsAnswers);
      this.emptyFileds = questionKeys
        .filter(key => !this.questionsAnswers[key])
        .map(key => currentModuleQuest[key]);

      if (currentModuleQuest.question6) {
        const question6Empty = !this.daysSelected.daysWhere.some(
          day => day.value
        );

        if (question6Empty) this.emptyFileds.push(currentModuleQuest.question6(this.parentName));
      }
      this.modalValidateSendData = this.emptyFileds.length ? true : false;
      if (!this.modalValidateSendData) {
        this.sendData();
      }
    },
    mapDaysData(day) {
      const filterDays = day.filter(day => {
        return day.value;
      });
      const dataArray = filterDays.map(day => {
        return {
          day: day.code,
          hour: day.time
        };
      });
      return dataArray;
    },
    newPlanFactory({ whatDays, whereDays }) {
      const newPlanData = {
        daysTime: whatDays,
        where_place: this.questionsAnswers.question3,
        what_activities: this.questionsAnswers.question4,
        how_remember: this.questionsAnswers.question5,
        extra_data: this.extralabelInput,
        whenCheckDays: whereDays,
        child: this.userIsAParent
          ? this.sessionStore.childSelectedId
          : this.sessionStore.userId,
        module: this.moduleOrder,
      };
      return newPlanData;
    },
    saveResponseOnPlan(responseData){
      const howRememberItem= this.rememberOptions.find((element)=>element.id == responseData.plan.how_remember_id)
      let howRememberText = ""
      if(howRememberItem){
        howRememberText = howRememberItem.name
      }
      this.newPlan = { 
        how_remember: howRememberText, 
        ...responseData.plan
      }
    },
    async sendData() {
      const whatDays = this.mapDaysData(this.daysSelected.daysWhat);
      const whereDays = this.mapDaysData(this.daysSelected.daysWhere);
      const planData = { whatDays, whereDays };

      const newPlanData = this.newPlanFactory(planData);

      if (this.plan) {
        newPlanData['planId'] = this.plan.id;
        newPlanData['parentEdit'] = false;
        editPlan(newPlanData).then((response)=>{
          this.saveResponseOnPlan(response)
          this.routePlanningView();
        })
      } else {
        createNewPlan(newPlanData)
          .then((response)=>{
            this.saveResponseOnPlan(response)
            if(response.coins){
              this.coins = {
                coins: response.coins,
                points: response.points,
                description: response.description
              }; 
              this.$bvModal.show(`${this.moduleOrder}-modal`);
            }
            else{
              this.routePlanningView()
            }
          })
          .catch((error)=>{
            console.log("error",error)
          })
      }
    },
    routePlanningView() {
      this.$emit('activeViewMode', this.newPlan);
    }
  }
}
</script>